import isEmpty from 'lodash/isEmpty';

function hasProperties(element) {
  if (!element) {
    return false;
  }

  return !isEmpty(element.content);
}

export {
  hasProperties,
};



// WEBPACK FOOTER //
// ./src/Modules/ElementUtils/object.js